module.exports = "https://www.gc-qa.gnp.com.mx/3672afcdf81f9013f80289cb9c0448d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-conductor.svg
// module id = 1823
// module chunks = 0